import userManagementService from "@/api/userMangementService";
import { MESSAGES } from "@/utils/constants";
import { notify, notifyError } from "@/utils/notification-helper";

const state = {};

const getters = {
   getLoaderStatus: (state, getters, rootState, rootGetters) => rootGetters.getLoaderStatus,
   getUsers: (state, getters, rootState, rootGetters) => rootGetters.getUsers,
   getUserRoles: (state, getters, rootState, rootGetters) => rootGetters.getUserRoles,
};

const actions = {
    async loadUserRoles({ commit }) {
        const response = await userManagementService.getUserRoles();
        commit('setUserRoles', response.data.result, { root: true });
    },
    async loadUsers({ commit }) {
        const response = await userManagementService.getUsers();
        commit('setUsers', response.data.result, { root: true });
    },
    async addUser ({ commit }, body) {
        const { data } = await userManagementService.addUser(body);
        if (data.status) {
            commit('addUser', data.result, { root: true });
            notify(MESSAGES.RECORD_CREATE_SUCCESS);
        } else {
            notifyError(data.message);
        }
        return data;
    },
    async updateUser ({ commit }, body) {
        await userManagementService.updateUser(body.id, body);
        commit('updateUser', body, { root: true });
    },
    async removeUser ({ commit }, id) {
        await userManagementService.removeUser(id);
        commit('removeUser', id, { root: true });
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};